module.exports = __webpack_public_path__ + "static/media/instagram.1566a790.png";